import React, { type FC } from "react";

import { FilterFormBuilder } from "../FilterFormBuilder/FilterFormBuilder";
import { type FilterFormPropsBase } from "../types/props";
import { getAssessmentFilters } from "./assessmentFilters";
import { type AssessmentFiltersEnum } from "../../../features/Library/Assessments/types/state";

export interface AssessmentFilterFormForPacksProps extends FilterFormPropsBase<AssessmentFiltersEnum> {}

const AssessmentFilterFormForPacks: FC<AssessmentFilterFormForPacksProps> = ({
  filterOptions,
  filter,
  updateFilter,
  onValidationChange,
}) => (
  <FilterFormBuilder
    filterOptions={filterOptions}
    filter={filter}
    updateFilter={updateFilter}
    items={getAssessmentFilters(false)}
    onValidationChange={onValidationChange}
  />
);

export default AssessmentFilterFormForPacks;
